import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const config = {
  plugins: [createPersistedState()],
  // 定义状态
  state: {
    name: '游客',
    uuid: null,
    Session: null,
    i18n: 'es',
    dev: false,
    ibnumber: null,
    avatarvip: 'https://api.freepos.es/files/sample/user_icon.jpg',
    defaultaddress: 0,
    myinfo: {
      id: null,
      sellerID: 1,
      openId: '',
      name: '',
      hash: '',
      addres: []
    },
    orders: {
      remark: null,
      payMode: null,
      totalPrice: 0
    },
    carData: {}, // 购物车
    selectFoods: [],
    ver: 1
  },
  // getters
  getters: {
    // isLogin:(state) =>{
    //     return state.isLogin;
    // },
    // 等同上面的写法
    isLogin: state => state.isLogin
  },
  methods: {
    isNull(exp) {
      return !exp && typeof (exp) !== 'undefined' && exp !== 0
    }
  },
  // 修改state里面的变量
  mutations: {
    // state指向上面的state,payload是调用muation时传过来的参数
    updateLogin(state, payload) {
      state.isLogin = payload
    },
    updateName(state, payload) {
      state.name = payload
    },
    addOne(state, payload) {
      state.count = state.count + 1
    },
    minusOne(state, payload) {
      if (state.count > 0) {
        state.count = state.count - 1
      }
    },
    updateCartNum(state, payload) {
      state.cartNum = payload
    },
    // 保存店面ID
    updateIbnumber(state, payload) {
      console.log(`ibnumber payload`, payload)
      var ibnumber = typeof (payload) === 'undefined' ? '' : '&ibnumber=' + payload
      console.log(`ibnumber fin`, ibnumber)
      state.ibnumber = ibnumber
    },
    // 保存整个设置
    saveinfo(state, payload) {
      state = payload
    },
        // 保存付款方式
    savepaymode(state, payload) {
      state.orders.paymode = payload
    },
        // 保存默认地址
    savedefaultaddress(state, payload) {
      state.defaultaddress = payload
    },
     // 保存myinfo
    savemyinfo(state, payload) {
      state.myinfo = payload
    },
    // 保存将要传出的购物车
    savecarData(state, payload) {
      state.carData = payload
    },
    // 保存本地购物车
    savecarselectFoodsa(state, payload) {
      state.selectFoods = payload
    },
    saveinfoRemote(state, payload) {
      if (state.dev) console.log('保存到主机1', payload)
      state.myinfo.addres[payload.id] = payload
    },
    // 升级设置
    upgrade(state, payload) {
      var lastVer = 3
      console.log('upgrade', state.ver !== lastVer)
      if (state.ver !== lastVer) {
        state.name = 'Guest'
        state.uuid = null
        state.Session = null
        state.i18n = 'es'
        state.dev = false
        state.ibnumber = null
        state.avatarvip = 'https://api.freepos.es/files/sample/user_icon.jpg'
        state.defaultaddress = 0
        state.myinfo = {
          ID: null,
          SellerID: 1,
          openId: '',
          name: '',
          hash: '',
          addres: []
        }
        state.orders = {
          remark: null,
          payMode: null,
          totalPrice: 0
        }
        state.carData = {} // 购物车
        state.selectFoods = []
        state.ver = lastVer
      }
      console.log('upgrade', state)
    }
  },

  // action行为
  actions: {
    /**
    * 修改num的action
    * Action 类似于 mutation，都是用来修改vuex的状态
    * Action 可以包含任意异步操作
    * @param {*} ctx 可以拿到一个类似store的实例
    * @param {*} payload 修改的数据
    */
    addOne(ctx, payload) {
      setTimeout(() => {
        ctx.commit('addOne', payload)
      }, 3000)
    },
    updateCartNum(ctx, payload) {
      setTimeout(() => {
        ctx.commit('updateCartNum', payload)
      }, 3000)
    },
    updateIbnumber(ctx, payload) {
      setTimeout(() => {
        ctx.commit('updateIbnumber', payload)
      }, 3000)
    },
     // 保存整个设置
    saveinfo(ctx, payload) {
      setTimeout(() => {
        ctx.commit('saveinfo', payload)
      }, 3000)
    },
    // 保存付款方式
    savepaymode(ctx, payload) {
      setTimeout(() => {
        ctx.commit('savepaymode', payload)
      }, 3000)
    },
    // 保存默认地址
    savedefaultaddress(ctx, payload) {
      setTimeout(() => {
        ctx.commit('savedefaultaddress', payload)
      }, 3000)
    },
     // 保存购物车
    savecarData(ctx, payload) {
      setTimeout(() => {
        ctx.commit('savecarData', payload)
      }, 3000)
    },
    // 保存本地购物车
    savecarselectFoodsa(ctx, payload) {
      setTimeout(() => {
        ctx.commit('savecarselectFoodsa', payload)
      }, 3000)
    },
    saveinfoRemote(ctx, payload) {
      setTimeout(() => {
        ctx.commit('saveinfoRemote', payload)
      }, 3000)
    }
  },

  // module
  modules: {

  }
}
export default new Vuex.Store(config)




// WEBPACK FOOTER //
// ./src/store/index.js